module.exports = __webpack_public_path__ + "img/drawFadeText3.8ce83985.png";